import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { EmailCampaign } from '../EmailCampaign';
import { RouteConstants } from '@/features/router/RouteConstants';

export const CampaignsEmailCreateFlowV2: FC = () => {
  const history = useHistory();

  const handleExitToList = () => {
    history.push(RouteConstants.emailCampaigns);
  };

  return <EmailCampaign mode='create' onExitToList={handleExitToList} />;
};
